import React from "react";
import { useNavigate } from "react-router-dom";
import categories from "../data/Categories.json"; // 🟡 استيراد الكاتيجوريز
import '../Products.css'
function CategoriesPage() {
  const navigate = useNavigate();
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4 main-color fw-bold">Categories</h2>
      <div className="row">
        {categories.map((cat) => (
          <div key={cat.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
          <div 
            className="card h-100 shadow-sm border-0 rounded-4 hover-card"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/categories/${cat.id}`)}
          >
              <img
                src={cat.image}
                className="card-img-top rounded-top-4"
                alt={cat.name}
                style={{ height: "180px", objectFit: "cover" }}
              />
              <div className="card-body text-center">
                <h5 className="card-title main-color">{cat.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoriesPage;
